import { v4 } from "uuid";
import API from "..";
import { isArray } from "lodash";

export function isYoutubeConfigured(videoStream: VideoStream): Promise<boolean> {
  return new Promise((resolve, reject) => {
    let resolved = false;;

    let EDGE_DEVICE = process.env.REACT_APP_STACK === 'prod' ? 'a8_a1_59_da_31_b1' : 'a8_a1_59_9e_d4_54';

    if (videoStream.iotThingName && process.env.REACT_APP_STACK === 'prod') {
      if (videoStream.iotThingName !== "DETACHED") {
        EDGE_DEVICE = videoStream.iotThingName;
      }
    }

    const uuid: string = v4();

    const sub = API.PubSub.subscribeToTopic(`edge/${EDGE_DEVICE}/http/responses/${uuid}`, (message: any) => {
      resolved = true;
      sub?.unsubscribe();

      if (message && message?.status && message.status === 200) {
        if (message.response && isArray(message.response) && message.response.includes(videoStream.kvsName)) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else {
        reject(false);
      }
    });

    const message = {
      "device": {
        "manufacturer": "Edge",
      },
      "action": "streaming/youtube/list",
    };

    API.PubSub.publishOnTopic(`edge/${EDGE_DEVICE}/http/requests/${uuid}`, message);

    setTimeout(() => {
      if (resolved === false) reject();
    }, 6000)
  })
}